const createFooterName = () => {
  document.addEventListener('DOMContentLoaded', function () {
    const footer = document.querySelector('.footer');

    if (!footer) {
      return;
    }

    var svg = document.getElementById('authorNameSvg');
    var text = document.getElementById('authorText');

    function adjustViewBox() {
      var bbox = text.getBBox();
      svg.setAttribute('viewBox', '0 0 ' + bbox.width + ' ' + bbox.height);
    }

    adjustViewBox();
  });
};

export { createFooterName };
